import Vue from "vue";
import VueLogger from "vuejs-logger"; // https://www.npmjs.com/package/vuejs-logger
import appConfig from "../../app-config";

const options = {
  isEnabled: false,
  logLevel: appConfig.VUE_APP_ERROR_LEVEL,
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
};

Vue.use(VueLogger, options);
